const defaultState = [];


export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_BIDS':
      return action.bids;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/bids.js